import { deepFreeze } from '../../utils/misc_utils';

export const ReservationStoreStatusEnum = deepFreeze({
    UNKNOWN: {
        value: 'UNKNOWN',
        label: 'Błąd'
    },
    READY_FOR_REALIZATION: {
        value: 'READY_FOR_REALIZATION',
        label: 'Gotowe do realizacji'
    },
    ERROR_IN_RESERVATION: {
        value: 'ERROR_IN_RESERVATION',
        label: 'Błąd w zamówieniu'
    },
    IN_PROGRESS: {
        value: 'IN_PROGRESS',
        label: 'W trakcie realizacji'
    },
    PREPARED_DELIVERY: {
        value: 'PREPARED_DELIVERY',
        label: 'Przygotowana dostawa'
    },
    COMPLETED: {
        value: 'COMPLETED',
        label: 'Zrealizowane'
    }
});

export const ReservationStatusEnum = deepFreeze({
    UNKNOWN: {
        value: 'UNKNOWN',
        label: 'Błąd'
    },
    NEW: {
        value: 'NEW',
        label: 'Nowe'
    },
    CANCELED_BY_STORE: {
        value: 'CANCELED_BY_STORE',
        label: 'Anulowane (przez dostawce)'
    },
    CANCELED_BY_CUSTOMER: {
        value: 'CANCELED_BY_CUSTOMER',
        label: 'Anulowane (przez użytkownika)'
    },
    WAITING_FOR_PAYMENT: {
        value: 'WAITING_FOR_PAYMENT',
        label: 'Oczekuje płatności'
    },
    PAID: {
        value: 'PAID',
        label: 'Opłacone'
    },
    UNPAID: {
        value: 'UNPAID',
        label: 'Nieopłacone'
    },
    DELIVERED: {
        value: 'DELIVERED',
        label: 'Dostarczone'
    },
    PREPARED: {
        value: 'PREPARED',
        label: 'Przygotowane'
    },
    FINISHED: {
        value: 'FINISHED',
        label: 'Zrealizowane'
    },
    PARTIALLY_RETURNED: {
        value: 'PARTIALLY_RETURNED',
        label: 'Częściowy zwrot'
    },
    RETURNED: {
        value: 'RETURNED',
        label: 'Zwrot'
    }
});
